export enum ParameterType {
Days,
Hours,
Fixed,
}
